import { GzExchangeAntimalwareScanTasksFormWebComponent } from './component/GzExchangeAntimalwareScanTasksFormWebComponent';

export { GzExchangeAntimalwareScanTasksFormWebComponent };
